import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import formatDate from '../../../../../../app/frontend/components/components/utils/formatDate';
import useBreakpoint from '../../../../shared/hooks/useBreakpoint';

const Applying = ({ offer: { timelines, user_offer:userOffer } }) => {
  const breakpoint = useBreakpoint();
  const { t } = useTranslation();

  if (!userOffer || !userOffer.participation_form_completed_at) return <div></div>;

  return (
    <React.Fragment>
      {breakpoint !== 'xs' ?
        <h3 className="mb-4-5">{t('influencers.pages.campaign.status.applying')}</h3> :
        <h4 className="mb-4-5">{t('influencers.pages.campaign.status.applying')}</h4>
      }
      <p>
        {t('influencers.pages.campaign.status.desc_applying')}
      </p>
      <div className="text-3">
        {t('influencers.pages.campaign.hiring_date')}
      </div>
      <div className="text-medium-1">
        {formatDate(timelines.hiring)}
      </div>
    </React.Fragment>
  );
};

Applying.propTypes = {
  offer: PropTypes.object.isRequired
};

export default Applying;
